import { PageHeaderSchemeDefinition } from "./page-header-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createPageHeaderMapDefinition } from "../../../utils/scheme-helper";

export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP,
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export const PAGE_HEADER_INDICATOR_COLOR_LIGHT = "light";
export const PAGE_HEADER_INDICATOR_COLOR_DARK = "dark";
export const PAGE_HEADER_INDICATOR_COLORS = [
  PAGE_HEADER_INDICATOR_COLOR_LIGHT,
  PAGE_HEADER_INDICATOR_COLOR_DARK
] as const;

export const PAGE_HEADER_VARIANT_HORIZONTAL = "horizontal";
export const PAGE_HEADER_VARIANT_VERTICAL = "vertical";
export const PAGE_HEADER_VARIANT_IMAGE = "image";
export const PAGE_HEADER_VARIANT_OFFSET_IMAGE = "offset-image";
export const PAGE_HEADER_VARIANT_OFFSET_VIDEO = "offset-video";

export const PAGE_HEADER_VARIANTS = [
  PAGE_HEADER_VARIANT_HORIZONTAL,
  PAGE_HEADER_VARIANT_VERTICAL,
  PAGE_HEADER_VARIANT_IMAGE,
  PAGE_HEADER_VARIANT_OFFSET_IMAGE,
  PAGE_HEADER_VARIANT_OFFSET_VIDEO
] as const;

function createSchemes() {
  let newSchemes: AllColors.PageHeaderSchemeConfiguration<PageHeaderSchemeDefinition> = {};
  AllColors.PAGE_HEADER_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      contentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      linkHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      gradientColor: ""
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const PAGE_HEADER_SCHEME_CONFIG: AllColors.PageHeaderSchemeConfiguration<PageHeaderSchemeDefinition> = createSchemes();

export const PAGE_HEADER_SCHEME_MAP: Map<BackgroundColor | "default", PageHeaderSchemeDefinition> = new Map(
  Object.entries(createPageHeaderMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    PAGE_HEADER_SCHEME_CONFIG[config as string]
  ])
);
